// local
import { IEventAggregator } from './eventaggregator.interface';

/**
 * @description: Aggregates a collection of subscription objects for a given channel.
 * @property channels: Available channels to be listening for events on.
 * @method publish: Publish an event to an existing channel.
 * @method subscribe: Subscribe to an existing event channel.
 * @method unsubscribe Unsubscribe from an existing event channel.
 */
class EventHub implements IEventAggregator {
  public channels: any = { };

  constructor() { }

  publish(channel: string, ...args) {
    if (!channel) throw new Error('EventHub Error: channel not found');
    if ( !(channel in this.channels) ) this.channels[ channel ] = [ ];

    var subscriptions = this.channels[channel];
    for (let i = 0, len = subscriptions.length; i < len; i++) subscriptions[i].handler.apply(subscriptions[i], args);

    return this;
  }

  subscribe(channel: string, handler: Function) {
    if (!channel || !handler) throw new Error('EventHub Error: channel or handler doesn\'t exist');
    if ( !(channel in this.channels) ) this.channels[ channel ] = [ ];
    this.channels[ channel ].push({ channel, handler, context: this });

    return this;
  }

  unsubscribe(channel: string, handler: Function) {
    if ( !(channel in this.channels) ) this.channels[ channel ] = [ ];
    var channels = this.channels[channel];
    for (let i = channels.length; i--;) if (channels[i].handler === handler) channels.splice(i, 1);
    return this;
  }

}

export { EventHub };
